import React, { Fragment, useEffect, useState, useContext } from 'react';
import {
  getDangerProducts,
  getFilterOptions,
  getCategoryFilter,
} from '../../core/services';
import ResponsivePagination from 'react-responsive-pagination';

import { useParams } from 'react-router-dom';
import { AppContext } from '../../core/Contexts/AppContext';
import CardDp from '../../component/Card/CardDp';
import { useLocation } from 'react-router-dom';
import { DangerProductFilter } from '../../component/Section/DangerProductFilter';

const DangerProducts = () => {
  const [filters, setFilters] = useState({});
  const [products, setProducts] = useState([]);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [page, setPage] = useState(1);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const params = useParams();
  const location = useLocation();

  const { setTitle, setHeaderType, setImage } = useContext(AppContext);

  const [filtersOptions, setFiltersOptions] = useState({
    categories: [],
    countries: [],
    risks: [],
    danger_levels: [],
    product_filters: [],
  });

  useEffect(() => {
    void getDangerProducts(page, filters).then((result) => {
      setProducts(result.data);
      setTotalPageCount(result.last_page);
    });

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [page, filters]);

  useEffect(() => {
    setTitle('საფრთხის შემცველი პროდუქტები');
    setImage('../../images/hero-images/pattern-bg-optimized.jpg');
    setHeaderType(1);

    void getFilterOptions()
      .then((options) => {
        setFiltersOptions({ ...options });
      })
      .catch((error) => {
        console.error('Error fetching filters:', error);
      });
  }, []);

  useEffect(() => {
    if (filters.search_category) {
      void getCategoryFilter(filters.search_category)
        .then((options) => {
          setFiltersOptions((prev) => {
            return {
              ...prev,
              product_filters: options,
            };
          });
        })
        .catch((error) => {
          console.error('Error fetching filters:', error);
        });
    }
  }, [filters.search_category]);

  const handleFilterChange = (prop, name) => {
    if (prop.target?.value) {
      setFilters((prev) => ({ ...prev, [name]: prop.target.value }));
    } else {
      if (Array.isArray(prop)) {
        setFilters((prev) => ({ ...prev, [name]: prop.map((x) => x.value) }));
      } else {
        setFilters((prev) => ({ ...prev, [name]: prop.value }));
      }
    }
  };

  return (
    <Fragment>
      <div className='news_container'>
        <section className='container'>
          <button
            className='d-block ml-auto semi-bold font__size--14 text__14-1024 btn btn__outlined--blue color__blue no__opacity rounded-2 shadow'
            onClick={() => setIsFilterVisible(!isFilterVisible)}
          >
            {isFilterVisible ? 'ფილტრის გათიშვა' : 'ფილტრის ჩვენება'}
          </button>

          {isFilterVisible && (
            <DangerProductFilter
              filtersOptions={filtersOptions}
              filterChanged={handleFilterChange}
            />
          )}
          <div className='row mt-3'>
            {products.length > 0 ? (
              products.map((product) => (
                <div key={product.id} className='col-lg-4 mb-4'>
                  <CardDp data={product} currentPath={location.pathname} />
                </div>
              ))
            ) : (
              <div className='col-12 text-center'>
                <p className='alert alert-warning'>
                  ვერ მოიძებნა საფრთხის შემცველი პროდუქტი.
                </p>
              </div>
            )}
          </div>
          {totalPageCount > 1 && (
            <ResponsivePagination
              current={page}
              total={totalPageCount}
              onPageChange={setPage}
              maxWidth={640}
            />
          )}
        </section>
      </div>
    </Fragment>
  );
};

export default DangerProducts;
